export default "__VITE_ASSET___XN4s2i5__"